<template>
    <div class="vue-dropdown-filter" :class="{ 'is-disabeld': disabled }" v-show="hasOptions === true">
        <v-select v-model="selectedValue" :options="options" :disabled="! hasOptions || disabled" :label="label" :placeholder="placeholder" @input="handleInput"></v-select>
    </div>
</template>

<script>
import baseFilter from '../mixins/baseFilter';

export default {
    name: "OccasionDropdownFilter",

    mixins: [baseFilter],

    props: {
        disabled: {
            type: Boolean,
            default: false
        },

        options: {
            type: Array,
            default: () => []
        },

        placeholder: {
            type: String
        },

        label: {
            type: String,
            default: 'name'
        }
    },

    data() {
        return {
            selectedValue: null
        }
    },

    computed: {
        hasOptions() {
            return !_.isEmpty(this.options);
        },

        localStorageValue() {
            let localStorageFilters = localStorage.getItem('appliedFilters');

            if (_.isNil(localStorageFilters)) {
                return null;
            }

            localStorageFilters = JSON.parse(localStorage.getItem('appliedFilters'));

            if (_.isNil(localStorageFilters) || _.isEmpty(localStorageFilters)) {
                return null;
            }

            let localStorageEntry = _.find(localStorageFilters, {'key': this.filterKey});

            if (_.isNil(localStorageEntry) || _.isNil(localStorageEntry.value) || _.isEmpty(localStorageEntry)) {
                return null;
            }

            return localStorageEntry.value;
        }
    },

    mounted() {
        this.eventBus.$on('core-filter-changed', () => this.selectedValue = null);

        this.eventBus.$on('reset-filters', () => this.selectedValue = null );

        if (! _.isNil(this.localStorageValue)) {
            this.selectedValue = this.localStorageValue;
        }
    },

    methods: {
        handleInput(payload) {
            if (_.isNil(payload)) {
                this.eventBus.$emit('dropdown-emptied', this.filterKey);
                return;
            }

            this.eventBus.$emit('dropdown-changed', {
                filterKey: this.filterKey,
                value: payload,
                type: 'dropdown'
            });
        }
    }
}
</script>
